<template> 
  <div class="joinUs">
   <div class="banner">
      <img :src="$store.state.isMB?'static/mbimages/joinUs/banner.jpg':'static/images/joinUs/banner.jpg'" alt="">
      <div class="textNtitle">
        <div class="banner_title">加入我们</div>
        <div class="banner_text">这里有扁平化的管理，这里有一群专注做事的小伙伴，这里有开放的沟通文化，这里有轻松舒适的办公环境，这里有我们，这里欢迎你。</div>
      </div>
    </div>
    <div class="recruit" v-for="(job, index) in jobList" :key="job.name" :class="job.showDetail?'Opened':''">
      <div class="title">
        <span class="jobName">{{job.name}}</span>
        <span class="city"><img src="static/images/joinUs/position.png" alt="">{{job.city}}</span>
        <span class="detail" @click="open(index)">{{job.showDetail?'收起描述 ':'查看描述 '}}<img src="static/images/joinUs/detail.png" alt=""></span>
      </div>
      <div v-show="job.showDetail">
        <div class="jobDetail">
            <span>职位描述</span><div class="dashed"></div>
        </div>
        <ul>岗位职责:
            <li v-for="duty in job.dutyList" :key="duty">{{duty}}</li>
        </ul>
        <ul>岗位要求:
            <li v-for="require in job.requireList" :key="require">{{require}}</li>
        </ul>
        <div class="email">简历发送至：hrbj@eccc.cc</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      jobList: [
        { name: 'Java高级工程师', city: '北京、广州、汕头', showDetail: false, dutyList: ['参与需求讨论，了解产品详细需求；','通过熟悉、运用公司自有架构平台进行设计、开发、和维护；','参与产品的架构设计，分析和发现系统的优化点；','学习和研究新技术以满足产品的新需求；'], requireList: ['大专及以上学历，有java实际开发经验;','熟悉JSP、Servlet、taglib等的原理及使用;熟练应用struts2、spring、hibernate、mybatis等J2EE技术平台和主流框架;','对数据库MYSQL/ORACLE有一定了解，熟练使用sql语句;','有linux/unix平台的操作、部署和维护经验优先;','有保险行业/汽车后市场行业的项目经验优先考虑；','能接受挑战，勇于开拓，积极进取，具备学习能力。'] },
        { name: 'WEB前端开发工程师', city: '北京、广州、汕头', showDetail: false, dutyList: ['负责互联网产品前端设计开发;','参与设计体验、流程的制定和规范，组织设计评审;','负责与设计师和后台程序配合，高效率高质量地完成页面的实现工作。'], requireList: ['三年以上工作经验;','熟练掌握各种Web前端技术(HTML/CSS/Javascript等)和跨浏览器、跨终端的开发;','理解Web标准，对前端性能、可访问性、可维护性等相关知识有实际的了解和实践经验优先;','熟悉HTML5，掌握前沿JS类库和MVVM框架;','熟悉模块化、前端编译和构建工具，并理解其设计原理;','掌握一门服务端（Node/Java或其他语言）;','具备一定的项目管理能力，团队精神，优秀的跨团队沟通能力、协调能力和协作精神;','对前端有热情，具备技术前瞻性，性格开朗，乐观向上，善于分享;'] },
        { name: '车险理赔产品经理', city: '北京、广州、汕头', showDetail: false, dutyList: ['做好对产品的设计以及需求管理和对外沟通工作;','收集、整理、撰写需求文档资料','了解客户需求及变更，确认需求;','跟踪软件产品，参与公司产品测试、操作手册撰写，对产品进行跟踪和提出改善性建议等;','协助开发部进行系統操作、 需求分析及疑难跟进','熟练掌握公司产品，熟知功能特色，熟练系统操作，必要时对客户进行宣传介绍和应用培训。'], requireList: ['有从事保险行业/汽车后市场行业的项目经验优先考虑;','良好的沟通能力，能够有效衔接客户与开发的相关工作;','具有较强的逻辑思维能力和需求分析加工能力;','为人正直，工作责任心强，良好的团队意识。'] },
        { name: '人伤理赔产品经理', city: '北京、广州、汕头', showDetail: false, dutyList: ['利用医疗专业知识，编写案件风险控制逻辑规则;','负责人伤项目产品设计和项目管理工作;','收集人伤项目相关的资料，整合人伤项目内外部资源;','提出人伤项目开发需求，协助IT产品中心实现产品功能;','协助开发部进行系統操作、 需求分析及疑难跟进','完成研发中心负责人交办的其他任务。'], requireList: ['本科及以上学历，法律、医疗等相关专业；'] }
      ]
    }
  },
  mounted () {
    window.scroll(0,0)
  },
  methods: {
    open (index) {
      this.jobList[index].showDetail = !this.jobList[index].showDetail
    }
  }
}
</script>
<style lang="scss">
.joinUs{
  .banner{
    margin-bottom: 60px;
    @media screen and (max-width: 767px){
      margin-bottom: 40px;
    }
    .textNtitle{
      left: calc(50% - 340px);
      @media screen and (max-width: 767px){
        left: 0;
        width: 100%;
        padding: 0 4%;
        top: 20%;
      }
    }
    .banner_title,.banner_text{
      width: fit-content;
      text-align: center;
    }
    .banner_title{
      margin: auto;
    }
    .banner_text{
      font-size: 18px;
      width: 680px;
      @media screen and (max-width: 767px){
        font-size: 14px;
        width: 100%;
        margin-top: 5%;
        letter-spacing: 1px;
      }
      @media screen and (max-width: 350px){
        font-size: 12px;
      }
    }
  }
  .recruit{
    background: #f5f5f5;
    width: 1200px;
    height: 180px;
    padding: 56px 0 49px;
    margin: 0 auto 20px;
    @media screen and (max-width: 767px){
      width: 92%;
      margin: 0 4% 20px;
      padding: 5% 0 4%;
      height: 22.17vw;
    }
    @media screen and (max-width: 375px){
      height: 24vw;
    }
    .title{
      width: 1120px;
      height: 75px;
      margin: 0 auto 39px;
      position: relative;
      @media screen and (max-width: 767px){
        width: 92%;
        margin: auto;
        height: 18vw;
      }
      @media screen and (max-width: 375px){
        height: 20vw;
      }
      .city,.detail{
        position: absolute;
        letter-spacing: 2px;
        }
        .jobName{
          letter-spacing: 3px;
          color: #333;
          font-size: 26px;
          line-height: 21px;
          @media screen and (max-width: 767px){
            font-size: 20px;
          }
          @media screen and (max-width: 375px){
            font-size: 18px;
          }
        }
        .city{
        bottom: 0;
        left: 0;
        font-size: 18px;
        color: #666;
        line-height: 18px;
        @media screen and (max-width: 767px){
          bottom: 5vw;
          font-size: 16px;
        }
        @media screen and (max-width: 375px){
          font-size: 14px;
        }
          img{
            vertical-align: -2px;
            margin-right: 0.7rem;
          }
        }
        .detail{
        bottom: 0;
        right: 0;
        cursor: pointer;
        color: #666;
        line-height: 16px;
        @media screen and (max-width: 767px){
          bottom: 5vw;
        }
        @media screen and (max-width: 375px){
          font-size: 14px;
        }
          img{
            opacity: 0.7;
            transform: rotate(180deg);
            vertical-align: 1px;
            transition-duration: 0.3s;
          }
        &:hover {
          @media screen and (min-width: 768px){
            color: #999;
          }
          img{
            @media screen and (min-width: 768px){
              opacity: 0.45;
            }
          }
        }
      }
    }
    .jobDetail{
      width: 1120px;
      margin: auto;
      position: relative;
      @media screen and (max-width: 767px){
        width: 100%;
        padding: 0 4%;
      }
      & > span {
        font-size: 24px;
        color: #333;
        letter-spacing: 3px;
        @media screen and (max-width: 767px){
          font-size: 20px;
        }
      }
      .dashed{
        border-top:1px dashed #ddd;
        height:1px;
        width: 980px;
        position: absolute;
        top: 18px;
        right: 0;
        @media screen and (max-width: 767px){
          width: 60%;
          margin: 0 4% 0 2%;
        }
      }
    }
    ul {
      font-size: 20px;
      letter-spacing: 3px;
      color: #333;
      margin-top: 28px;
      padding-left: 64px;
      text-indent: -23px;
      @media screen and (max-width: 767px){
        padding: 0 4% 0 12%;
        text-indent: -23px;
        font-size: 16px;
      }
      li{
        list-style: decimal;
        letter-spacing: 2px;
        font-size: 16px;
        margin-top: 10px;
        text-indent: 0px;
        @media screen and (max-width: 767px){
          font-size: 14px;
        }
      }
      li:first-child{
        margin-top: 30px;
      }
    }
    .email{
      margin: 33px 0 0 40px;
    }
  }
  .recruit:last-of-type {
    margin-bottom: 60px;
    @media screen and (max-width: 767px){
      margin-bottom: 40px;
    }
  }
  .Opened{
    padding-bottom: 50px;
    height: fit-content;
    @media screen and (max-width: 767px){
      padding-bottom: 30px;
    }
    .detail img {
      transform: rotate(0) !important;
      transition-duration: 0.3s;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/comPages/joinUs.vue